import React, { createContext, useState, useContext, useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BookContext = createContext();

export const useBook = () => {
  const context = useContext(BookContext);
  if (!context) {
    throw new Error('useBook must be used within BookProvider');
  }
  return context;
};

export const BookProvider = ({ children }) => {
  const [books, setBooks] = useState([]);
  const [allBooks, setAllBooks] = useState([]);
  const [selectedBook, setSelectedBook] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMainBooks();
  }, []);

  const fetchMainBooks = async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/books/main-books`);
      if (res.ok) {
        const data = await res.json();
        const mainBooks = data.books || [];
        setBooks(mainBooks);

        // Restore last selected book from localStorage, or pick the first
        const savedId = localStorage.getItem('selectedBookId');
        const saved = mainBooks.find(b => b.book_id === savedId);
        if (saved) {
          setSelectedBook(saved);
        } else if (mainBooks.length > 0) {
          setSelectedBook(mainBooks[0]);
          localStorage.setItem('selectedBookId', mainBooks[0].book_id);
        }
      }
    } catch (err) {
      console.error('Failed to load books:', err);
    } finally {
      setLoading(false);
    }
  };

  const selectBook = (bookId) => {
    const book = books.find(b => b.book_id === bookId);
    if (book) {
      setSelectedBook(book);
      localStorage.setItem('selectedBookId', bookId);
    }
  };

  const refreshBooks = () => fetchMainBooks();

  return (
    <BookContext.Provider value={{ books, selectedBook, selectBook, loading, refreshBooks }}>
      {children}
    </BookContext.Provider>
  );
};
